export interface ParsedLineItem {
    original_text: string;
    values: {
        current: number | null;
        one_year_ago: number | null;
        two_years_ago: number | null;
    };
    suggested_subcategory_id: number | null;
    suggested_subcategory_name: string;
    confidence: number;
    reasoning: string;
}

export interface UnmappedItem {
    original_text: string;
    values: {
        current: number | null;
        one_year_ago: number | null;
        two_years_ago: number | null;
    };
    suggested_category_type: string;
    reasoning: string;
}

export interface AiResponse {
    // After period mapping: slot → human-readable label (e.g. "current" → "01/01/2024 through 12/31/2024")
    detected_years: Record<string, string>;
    line_items: ParsedLineItem[];
    unmapped_items: UnmappedItem[];
    warnings: string[];
}

export const SOURCE_SYSTEMS = [
    'Accountant Prepared',
    'AMS360',
    'Applied Epic',
    'Applied TAM',
    'Hawksoft / QuickBooks',
    'NowCerts',
    'Partner Platform',
    'QQ Catalyst',
    'QuickBooks',
    'Xero',
    'Other / Unknown',
] as const;

export type SourceSystem = typeof SOURCE_SYSTEMS[number];

export interface FeedbackEntry {
    text: string;
    scope: 'this_upload' | 'source_system';
    user_id: number;
    created_at: string;
}

export interface PlStatementUpload {
    id: number;
    valuation_id: number;
    user_id: number | null;
    original_filename: string;
    file_path: string;
    source_system: SourceSystem | null;
    status: 'pending' | 'processing' | 'parsed' | 'approved' | 'failed';
    extracted_text: string | null;
    ai_response: AiResponse | null;
    approved_mappings: ReviewLineItem[] | null;
    feedback: FeedbackEntry[] | null;
    error_message: string | null;
    created_at: string;
    updated_at: string;
}

export interface ReviewLineItem extends ParsedLineItem {
    include: boolean;
    subcategory_id: number | null;
    isUnmapped?: boolean;
    suggested_category_type?: string;
    analyst_note?: string | null;
}

export type MergeStrategy = 'replace' | 'fill_gaps' | 'skip';

export interface ExistingDataByColumn {
    current: boolean;
    one_year_ago: boolean;
    two_years_ago: boolean;
}
